import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { LocationForm } from '@/components/Forms';
import { PersonStores } from '@/store';
import { LocationFormInterface } from '@/types';
import { useToast } from 'primevue/usetoast';

/**
 * set up the toast
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileLocation',
  setup(__props) {

const toast = useToast();

/**
 * All of the state references including the convertion of the
 * profile location state object into a ref.
 */
const profileStore = PersonStores.useUserProfileStore();

/**
 * Handle save event emitted by the child component
 * in order to reset the user location data.
 */
const onSave = async (data: LocationFormInterface) => {
  profileStore.location = data;
  const response = await profileStore.updateLocationInfo(data);
  if (response === 200) {
    doToast();
  } else {
    doToast(true);
  }
};
/**
 * Display the toast message.
 */
const doToast = (error = false) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? 'there was an error' : 'Location information has been saved',
    life: 3000,
  });
};

return (_ctx: any,_cache: any) => {
  return (_unref(profileStore).location && _unref(profileStore).isAuth)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(LocationForm), {
          "permission-to-edit": true,
          data: _unref(profileStore).location,
          "is-organization": false,
          loading: _unref(profileStore).loading,
          onSave: onSave
        }, null, 8, ["data", "loading"])
      ]))
    : _createCommentVNode("", true)
}
}

})